import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form';
import { useDispatch } from 'react-redux';

import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';

import { KeyValue } from '@/main/models/common';
import { StatusRegisterEnum } from '@/main/services/enum/StatusRegisterEnum';
import { getTranslateByKey, isNullUndefined, isValueQueryParams } from '@/main/services/utils';
import { getBodyshops, resetReducerBodyshops, useBodyshopReducer } from '@/main/store/bodyshop';
import { useDinamicFiltersMappingCodes } from './dinamicFiltersMappingCodes';


export const INITIAL_FORM_STATE_BODYSHOP = {
  bodyshop: null as KeyValue | null,
};

export type IFormFiltersMappingTypeBodyshop = typeof INITIAL_FORM_STATE_BODYSHOP

interface IFiltersMappingTypeBodyshopProps { }
function FiltersMappingTypeBodyshop({
}: IFiltersMappingTypeBodyshopProps) {
  const dispatch = useDispatch();
  const {
    isEdit,
    keyReducer,
    watcherCountry,
    isRequiredField
  } = useDinamicFiltersMappingCodes();
  const { isolated: bodyshopReducer } = useBodyshopReducer(keyReducer);
  const {
    control,
    resetField,
    setValue
  } = useFormContext<IFormFiltersMappingTypeBodyshop>();

  useEffect(() => {
    if (!isValueQueryParams(watcherCountry)) {
      resetField('bodyshop');
    }
    if (isNullUndefined(watcherCountry)) return;

    dispatch(getBodyshops({ guidCountry: String(watcherCountry.key), idStatusRegister: StatusRegisterEnum.Active }, keyReducer));

    return () => {
      dispatch(resetReducerBodyshops());
    }
  }, [JSON.stringify(watcherCountry?.key)])

  const disabledBodyshop = isNullUndefined(bodyshopReducer.data) || bodyshopReducer.data.length === 1

  return (
    <>
      <KogAutoCompleteControlled
        id='id-mappingCode-select-bodyshop'
        nameCustom='bodyshop'
        label={getTranslateByKey('information.bodyshop')}
        isDefaultValueUnique
        control={control}
        setValueCustom={setValue}
        options={bodyshopReducer.data}
        isLoading={bodyshopReducer.isLoading}
        disabled={disabledBodyshop}
        rulesCustom={{ required: isRequiredField('bodyshop') }}
        onChangeCustom={() => { }}
      />
    </>
  )
}

export default FiltersMappingTypeBodyshop